import { Resizable } from 're-resizable';
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import CustomCheckboxSVG from './CheckboxSVG';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import { DEFAULT_HEIGHTS, DEFAULT_WIDTHS } from '../../../constants/pdfOverlayDimensions';

const CheckBoxContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CheckboxEditOverlayChip = ({ item, setIsResizing }) => {
  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    draggableFieldsData,
  } = useContext(FileContext);
  const { rgbMapper } = useColumnOrder();
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? rgbMapper[itemColor] ?? itemColor
    : '#E6E6FA';

  useEffect(() => {
    // set default width and height
    if (!item?.width) item.width = DEFAULT_WIDTHS.CHECKBOX;
    if (!item?.height) item.height = DEFAULT_HEIGHTS.CHECKBOX;
  }, []);

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    item.width += d.width;
    item.height += d.height;

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
    };
    updateFormFields([...addedFormFields]);
  };

  return (
    <>
      <Resizable
        id="checkbox"
        size={{ height: item?.height || 25, width: item?.width || 25 }}
        lockAspectRatio={true}
        enable={{
          top: false,
          right: item?.isActive,
          bottom: item?.isActive,
          left: false,
          topRight: false,
          bottomRight: item?.isActive,
          bottomLeft: false,
          topLeft: false,
        }}
        className={item.isActive ? 'resizeable active' : 'hover-active-dotted'}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeEnd(item)}
      >
        <CheckBoxContainer>
          <CustomCheckboxSVG fill={backgroundColor} />
        </CheckBoxContainer>
      </Resizable>
    </>
  );
};

export default CheckboxEditOverlayChip;
